import React, { Component, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BrowserRouter as Router, Redirect, Route, Switch, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import * as auth from 'actions/auth';
import * as company from 'actions/company';
import * as captainPayment from 'actions/captainPayment';

import { setUser } from 'helpers/logsUtils';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';
import cm from 'helpers/commons';
import { logout } from 'helpers/request';
import channelTalkService from 'helpers/channeltalk';

import * as cm_action from 'actions/commons';
import * as memberActions from 'actions/member';
// import { hot } from 'react-hot-loader/root';
import { Provider as HttpProvider } from 'use-http';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from 'react-query';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Loading from 'vcomponents/Loading';

const MainLayout = lazy(() => import('layouts/MainLayout'));

import { CaptainPaymentLayout } from 'layouts/styles';
import * as Containers from 'containers/index.tsx';

import api from 'config';
import errorHandler from 'apis/errorHandler';
import history from 'vendys/utils/history';
import { auth as authClient } from 'helpers/auth';

import {
  Login,
  // Main,
  LoginPasswordChange,
  RootCommonModal,
  ProposalStoreMap
} from 'containers';

import '../semantic/semantic';
import '../semantic/semantic.less';
import '../styles/company.less';

import Auth from './Auth';
import { getDivisionList } from '../actions/captainPayment';
import { MemberDivision } from '../actions/member';

const Main = lazy(() => import('containers/Main'));

const Landing = lazy(() => import('containers/Landing'));

// ##### Quick Service #####
const QuickAddressList = lazy(() => import('containers/Service/Quick/QuickAddressList'));
const QuickAgreement = lazy(() => import('containers/Service/Quick/QuickAgreement'));
const QuickGuidance = lazy(() => import('containers/Service/Quick/QuickGuidance'));
const QuickLanding = lazy(() => import('containers/Service/Quick/QuickLanding'));
const QuickManual = lazy(() => import('containers/Service/Quick/QuickManual'));
const QuickReservation = lazy(() => import('containers/Service/Quick/QuickReservation'));
const QuickReservationDetail = lazy(() => import('containers/Service/Quick/QuickReservationDetail'));
const QuickReservationList = lazy(() => import('containers/Service/Quick/QuickReservationList'));
const QuickStats = lazy(() => import('containers/Service/Quick/QuickStats'));
const QuickUserPermission = lazy(() => import('containers/Service/Quick/QuickUserPermission'));

const Benefits = lazy(() => import('containers/Service/Benefits'));
const ServiceIframe = lazy(() => import('containers/Service/ServiceIframe'));
const BizGift = lazy(() => import('containers/Service/BizGift'));
const EzwelPromotion = lazy(() => import('containers/Service/Ezwel'));

const CompanyWelfarePolicy = lazy(() => import('containers/Service/Welfare/CompanyWelfarePolicy'));
const UserWelfareGivenList = lazy(() => import('containers/Service/Welfare/UserWelfareGivenList'));
const RemainingWelfare = lazy(() => import('containers/Service/Welfare/RemainingWelfare'));
const StoreWelfareStats = lazy(() => import('containers/Service/Welfare/StoreWelfareStats'));
const ExcelDownloadHistories = lazy(() => import('containers/Service/Welfare/ExcelDownloadHistories'));
const WelfareGiveDeduct = lazy(() => import('containers/Service/Welfare/WelfareGiveDeduct'));

const WelfareLanding = lazy(() => import('containers/Service/Welfare/WelfareLanding'));

const AgreementHistory = lazy(() => import('containers/Service/Management/AgreementHistory'));
const ServiceAgreement = lazy(() => import('containers/Service/Management/ServiceAgreement'));
const UserManagement = lazy(() => import('containers/Service/Management/UserManagement'));
const DormantUserManagement = lazy(() => import('containers/Service/Management/DormantUserManagement'));
const UserDetail = lazy(() => import('containers/Service/Management/UserDetail'));
const DormantUser = lazy(() => import('containers/Service/Management/UserDetail/DormantUser'));
const CompanyInfo = lazy(() => import('containers/Service/Management/CompanyInfo'));
const CompanyInfoDetail = lazy(() => import('containers/Service/Management/CompanyInfoDetail'));
const TabHeader = lazy(() => import('containers/HeaderTab/index'));
const AuthRoute = lazy(() => import('vcomponents/AuthRoute'));
const PaymentsAuthRoute = lazy(() => import('vcomponents/AuthRoute/PaymentsAuthRoute'));
const MyInfo = lazy(() => import('containers/Service/Management/UserDetail/MyInfo'));
const UserManagements = lazy(() => import('containers/Service/Management'));
const Welfare = lazy(() => import('containers/Service/Welfare'));
const Footer = lazy(() => import('containers/Landing/Footer'));

const Notice = lazy(() => import('containers/Service/Management/Notice'));
const PushMessage = lazy(() => import('containers/Service/Management/CompanyPushMessage'));
// 이벤트 페지 미출로 변경
// const RecommendEvent = lazy(() => import('containers/RecommendEvent'));
const NotFound = lazy(() => import('containers/NotFound'));

const Finance = lazy(() => import('containers/Service/Finance'));

const ContentsWrapper = styled.div`
  // position: absolute;
  // inset: 16px;
  min-height: 100%;
  & > div {
    padding-bottom: 16px;
    // height: 100%;
    // width: 100%;
  }
`;

const queryClient = new QueryClient({
  defaultOptions: {
    staleTime: 1000,
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false
    }
  }
});

const options = {
  interceptors: {
    request: async ({ options, url, path, route }) => {
      const info = storage.get('info');
      const company = storage.get('company');
      const accessToken = await authClient.getValidAccessToken();

      if (url.indexOf(api.config.authAPI) < 0) {
        let isMe = false;

        if (
          url === api.config.companyAPI + '/addons/v1/me' ||
          url === api.config.companyAPI + '/captain-payment/pass/v1/me' ||
          url === api.config.companyAPI + '/captain-payment/pass/v1/service/sikdea' ||
          !company
        ) {
          isMe = true;
        }

        const headerInfo = isMe
          ? {
              Authorization: 'Bearer ' + accessToken
            }
          : {
              Authorization: 'Bearer ' + accessToken,
              'x-userid': company.user && company.user.id,
              'x-comid': company.id,
              'x-corp': info && JSON.stringify(info.auth)
            };

        options.headers = { ...options.headers, ...headerInfo };
        return options;
      }
      const headerInfo = { Authorization: 'Bearer ' + accessToken };
      options.headers = { ...options.headers, ...headerInfo };
      return options;
    },
    response: async ({ response }) => {
      const res = response;
      errorHandler({ response: res });
      if (response.ok) {
        return res;
      }
      const { data } = res;
      const { status, message } = data;
      if (status === -2302 || status === -2303 || status === -2304) {
        console.log('### : 인증 토큰 폐기');
        toastr('top-right', 'error', message);
        await logout();
      } else if (status === -2306) {
        console.log('### : 인증 만료');
        toastr('top-right', 'error', message);
        await logout();
      } else if (status === -2400 || status === 500) {
        toastr('top-right', 'error', message);
        if (status === -2400) {
          await logout();
        }
      }
    }
  },
  onError: async (e) => {
    const { error } = e;
    console.log(e);
    const { response: { data: response = {} } = {} } = error;
    const { status } = response;
    if (status === -2302 || status === -2303 || status === -2304) {
      console.log('### : 인증 토큰 폐기');
      toastr('top-right', 'error', response.message);
      await logout();
    } else if (status === -2306) {
      console.log('### : 인증 만료');
      toastr('top-right', 'error', response.message);
      await logout();
    } else if (status === -2400 || status === 500) {
      toastr('top-right', 'error', response.message);
      if (status === -2400) {
        await logout();
      }
    }
  }
};

class App extends Component {
  constructor(props) {
    super(props);
    this.rootProps = {
      fn: {
        meCall: this.meCall,
        divisionSel: this.divisionSel,
        divisionSelAll: this.staffDivisionSel
      },
      logout,
      data: {}
    };
  }

  async componentDidMount() {
    // channelTalkService.boot({
    //   pluginKey: api.config.channel_tolk_plugin_key, // please fill with your plugin key
    //   profile: {
    //     name: '로그인하지 않은 유저입니다.'
    //   }
    // });
    // await this.mePaymentCall();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const nProps = nextProps;
    const dProps = this.props;

    let result = false;

    const { company: companyInfo, form } = nextProps;

    if (companyInfo && companyInfo.data) {
      const companyStorage = storage.get('company');
      // 로그아웃·세션 정리 직후에는 localStorage 가 비어 있어 갱신할 대상이 없다
      if (!companyStorage) return result;

      const { userID: id } = companyStorage;
      const { id: companyId } = companyStorage;

      storage.set('company', {
        userID: form.userID ? form.userID.toLowerCase() : id.toLowerCase(),
        user: companyInfo.data.user,
        id: companyId || companyInfo.data.user.company.id,
        info: companyInfo.data.user.company,
        list: companyInfo.data.company
      });
      setUser();
      this.getDivisionALL();
    }

    return result;
  }

  componentWillUnmount() {
    // channelTalkService.shutdown();
  }

  getDivisionALL = async () => {
    const { cmAPI } = this.props;
    if (cmAPI) {
      const result = await cmAPI.getDivisionALL();

      if (result && result.value && result.value.data) {
        storage.set('maxDepth', result.value.data.depth);
      }
    }
  };

  getCaptainPaymentMe = async () => {
    const { captainPaymentAction } = this.props;
    await captainPaymentAction.captainPaymentMe();
  };

  mePaymentCall = async () => {
    const { authAction } = this.props;
    await authAction.mePaymentAPI({});
    // await authAction.serviceSikdaeAPI({ });
  };

  meCall = async () => {
    const { authAction } = this.props;
    const { id: companyId } = storage.get('company');
    await authAction.meAPI({ comId: companyId });

    const { company: companyInfo } = this.props;

    if (companyInfo && companyInfo.data) {
      const code = [];
      const { auth: authInfo } = companyInfo.data;

      if (authInfo.auth) {
        authInfo.auth.forEach((data) => {
          code.push(data.code);
        });
      }

      await storage.set('info', {
        auth: {
          auth: code,
          organization: authInfo.organization,
          type: authInfo.type,
          depth: authInfo.depth
        }
      });
    }
  };

  // ?? ??
  divisionSel = async () => {
    const { cmAPI } = this.props;
    const storageInfo = storage.get('info');

    try {
      const authList = ((storageInfo || {}).auth || {}).auth;
      if (!authList || authList.length === 0) return;
      await cmAPI.divisionSel();

      const { divisionList } = this.props;

      let navi = null;

      if (divisionList && divisionList.data) {
        const { division, depth } = divisionList.data;

        navi = cm.divisionNavigation(division);
        storage.set('depth', depth);
        storage.set('navi', navi);

        cmAPI.divisionNavi({
          type: 'navi',
          name: 'value',
          value: navi
        });

        this.staffDivisionSel();
      }
    } catch (e) {
      const response = e.response;

      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### division call error : ', e);
    } finally {
    }
  };

  // ??? ???? ????
  staffDivisionSel = async () => {
    const { cmAPI } = this.props;
    const params = { viewType: 'all' };

    try {
      await cmAPI.staffDivisionSel(params);

      const { staffDivisionList } = this.props;

      if (staffDivisionList && staffDivisionList.data) {
        const { division, depth } = staffDivisionList.data;
        const navi = await cm.divisionNavigation(division);

        cm.staffDivisionNavigation(depth, navi);
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        console.log('###### staffDivision call error : ', e);
      }
    }
  };

  setWelfareDivision = async () => {
    const { captainAPI, cmAPI } = this.props;
    const { value: divisionList } = await captainAPI.getDivision();
    if (divisionList && divisionList.data) {
      const { division, depth } = divisionList.data;

      const navi = cm.divisionNavigation(division);
      storage.set('depth', depth);
      storage.set('navi', navi);

      cmAPI.divisionNavi({
        type: 'navi',
        name: 'value',
        value: navi
      });
    }
  };

  render() {
    return (
      <HttpProvider options={options}>
        <QueryClientProvider client={queryClient}>
          <Router className="compnay-manager2" history={history}>
            <>
              <Suspense fallback={<Loading />}>
                <Switch>
                  <Route path="/(main|service|container)">
                    <CaptainPaymentLayout>
                      <TabHeader />
                      <Switch>
                        <Route path="/service/landing" render={({ history: h }) => <Landing history={h} />} />
                        {/* 이벤트 페이지 미노출 — 직접 URL 접속 시 서비스 랜딩으로 이동 */}
                        {/* <Route path="/service/event/landing" render={() => <RecommendEvent />} /> */}
                        <Redirect from="/service/event/landing" to="/service/landing" />
                        <Route path="/service/error/auth" render={({ history: h }) => <Auth history={h} />} />
                        <Route
                          path="/service/bizgift/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/compulsory/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/coffee/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/vendingmachine/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/benefitmall/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/foodtruck/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/message/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        <Route
                          path="/service/equipment/landing"
                          render={({ match }) => <ServiceIframe pathname={match.url} />}
                        />
                        {/*<Route path="/service/mro/landing" render={({ match }) => <ServiceIframe pathname={match.url} />} />*/}
                        <Route path="/service/*">
                          <MainLayout>
                            <Route
                              render={({ location }) => {
                                return (
                                  <TransitionGroup>
                                    <CSSTransition key={location.key} timeout={700} classNames="fade">
                                      <ContentsWrapper>
                                        <Switch location={location}>
                                          <Route path="/mro" render={() => <div>비품122구매</div>} />

                                          {/* ##### Quick Service #####  */}
                                          <Route
                                            path="/service/quick/landing"
                                            render={({ match }) => <ServiceIframe pathname={match.url} />}
                                          />
                                          <AuthRoute
                                            path="/service/quick/address"
                                            render={(props) => <QuickAddressList {...props} />}
                                          />
                                          <AuthRoute
                                            path="/service/quick/reservation/booking"
                                            render={(props) => <QuickReservation {...props} />}
                                          />
                                          <AuthRoute
                                            path="/service/quick/reservation/list"
                                            render={(props) => <QuickReservationList {...props} />}
                                          />
                                          <Route
                                            exact
                                            path="/service/quick/reservation/:quickManagerIdx"
                                            render={(props) => <QuickReservationDetail {...props} />}
                                          />
                                          <AuthRoute path="/service/quick/stats" render={() => <QuickStats />} />
                                          <AuthRoute
                                            path="/service/quick/permission"
                                            render={(props) => <QuickUserPermission {...props} />}
                                          />
                                          <AuthRoute path="/service/quick/guidance" render={() => <QuickGuidance />} />
                                          <AuthRoute path="/service/quick/manual" render={() => <QuickManual />} />
                                          <Route
                                            path="/service/quick/agreement"
                                            render={({ history: h }) => (
                                              <QuickAgreement history={h} key="QuickAgreement" />
                                            )}
                                          />
                                          {/*  */}

                                          <Route
                                            path="/service/myInfo"
                                            render={({ history: h }) => <MyInfo history={h} />}
                                          />
                                          <AuthRoute
                                            path="/service/management/captainPayments/agreement/history"
                                            render={(props) => <ServiceAgreement {...props} />}
                                          />
                                          <AuthRoute
                                            path="/service/management/company/(users|dormant)"
                                            render={(props) => <UserManagements {...props} />}
                                          />
                                          <AuthRoute
                                            exact
                                            path="/service/management/company/info"
                                            render={() => <CompanyInfo />}
                                          />
                                          <Route
                                            exact
                                            path="/service/management/company/info/:clientContractIdx"
                                            render={(props) => <CompanyInfoDetail {...props} />}
                                          />
                                          <AuthRoute
                                            exact
                                            path="/service/management/company/notice"
                                            render={(props) => <Notice {...props} />}
                                          />
                                          <AuthRoute
                                            exact
                                            path="/service/management/company/pushMessage"
                                            component={PushMessage}
                                          />

                                          <Route
                                            path={`/service/welfare/landing`}
                                            render={({ match }) => <ServiceIframe pathname={match.url} />}
                                          />
                                          <Route
                                            path="/service/welfare"
                                            render={(props) => (
                                              <Welfare getDivision={this.setWelfareDivision} {...props} />
                                            )}
                                          />
                                          {Object.keys(Containers).map((id) => {
                                            const View = Containers[id];
                                            return (
                                              <Route
                                                key={id}
                                                path={`/service/container/${id}`}
                                                render={({ history: h }) => <View history={h} />}
                                              />
                                            );
                                          })}

                                          {/* 정산관리 — 메뉴별 권한 체크(AuthRoute)는 Finance 라우터 안에서 한다 */}
                                          <Route path="/service/finance" component={Finance} />
                                          <Route path="*" render={() => <NotFound />} />
                                        </Switch>
                                      </ContentsWrapper>
                                    </CSSTransition>
                                  </TransitionGroup>
                                );
                              }}
                            />
                            <Footer rootProps={this.rootProps} />
                          </MainLayout>
                        </Route>
                        <Route
                          path={'/main/*'}
                          render={(props) => {
                            return <Main {...props} rootProps={this.rootProps} />;
                          }}
                        />
                        <Route path="*" render={() => <NotFound />} />
                        <RootCommonModal />
                      </Switch>
                    </CaptainPaymentLayout>
                  </Route>
                  <Route
                    exact
                    path="/"
                    render={(props) => {
                      return <Login {...props} rootProps={this.rootProps} />;
                    }}
                  />
                  <Route
                    path="/passwordChange"
                    render={(props) => {
                      return <LoginPasswordChange {...props} rootProps={this.rootProps} />;
                    }}
                  />
                  <Route path="/proposal/:id" component={ProposalStoreMap} />
                  <Route path="*" render={() => <NotFound />} />
                </Switch>
              </Suspense>
            </>
          </Router>
        </QueryClientProvider>
      </HttpProvider>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object.isRequired
};

App = connect(
  (state) => ({
    company: state.auth.company,
    form: state.form.login,
    divisionList: state.commons.division,
    navi: state.commons.navi,
    staffDivisionList: state.commons.staffDivision
  }),
  (dispatch) => ({
    authAction: bindActionCreators(
      {
        meAPI: auth.meAPI,
        mePaymentAPI: auth.mePaymentAPI,
        serviceSikdaeAPI: auth.serviceSikdaeAPI
      },
      dispatch
    ),
    cmAPI: bindActionCreators(
      {
        divisionSel: cm_action.DivisionList,
        divisionNavi: cm_action.ReduxDataSet,
        staffDivisionSel: cm_action.StaffDivisionList,
        getDivisionALL: cm_action.getDivisionALL
      },
      dispatch
    ),
    captainAPI: bindActionCreators(
      {
        getDivision: memberActions.MemberDivision
      },
      dispatch
    )
  })
)(App);

// export default App;
export default // hot(
withRouter(App);
// );
